export default __webpack_public_path__ + "static/media/correct.ad8d0e73.svg";